import React from 'react';
import { Link } from 'react-router-dom';
import Layout from './Layout';

const ATAJOS = [
    { href: '/#planesInternet', icono: 'fas fa-wifi', titulo: 'Planes', texto: 'Fibra óptica e inalámbrico' },
    { to: '/cobertura', icono: 'fas fa-map-marker-alt', titulo: 'Cobertura', texto: 'Busca tu comunidad' },
    { to: '/promociones', icono: 'fas fa-tags', titulo: 'Promociones', texto: 'Instalación y meses gratis' },
    { to: '/internet/faq', icono: 'fas fa-question-circle', titulo: 'Preguntas frecuentes', texto: 'Pagos, soporte y más' },
];

const Atajo = ({ atajo }) => {
    const contenido = (
        <>
            <span className="coberturaMunicipio-icono"><i className={atajo.icono}></i></span>
            <span className="coberturaMunicipio-nombre">
                <b>{atajo.titulo}</b>
                <span>{atajo.texto}</span>
            </span>
            <span className="coberturaMunicipio-toggle"><i className="fas fa-arrow-right"></i></span>
        </>
    );
    return atajo.to
        ? <Link className="e404Atajo" to={atajo.to}>{contenido}</Link>
        : <a className="e404Atajo" href={atajo.href}>{contenido}</a>;
};

class E404 extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }
    render() {
        return (
            <div>
                <Layout title="Red Itmex - Página no encontrada">
                    <section className="paginaItmex paginaItmex--hero">
                        <div className="nosotrosHero e404Hero">
                            <span className="e404Hero-senal"><i className="fas fa-wifi"></i></span>
                            <span className="e404Hero-codigo">404</span>
                            <h1 className="heroItmex-title e404Hero-titulo">Oops! &#128540; Sin señal por aquí</h1>
                            <p className="heroItmex-subtitle">Creo que no encontramos lo que estás buscando. La página pudo cambiar de dirección o ya no existe.</p>
                            <div className="heroItmex-actions">
                                <Link className="heroItmex-cta" to="/">
                                    Ir al inicio
                                    <span className="heroItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
                                </Link>
                                <Link className="heroItmex-cta-secondary" to="/contacto">Contáctanos</Link>
                            </div>
                        </div>

                        <h2 className="promosItmex-grupo-titulo paginaItmex-seccion"><i className="fas fa-compass"></i>Quizá buscabas</h2>
                        <div className="e404Atajos">
                            {ATAJOS.map(atajo => <Atajo key={atajo.titulo} atajo={atajo} />)}
                        </div>
                    </section>
                </Layout>
            </div>
        )
    }
}

export default E404;
